import { Heading, Flex, Box, Paragraph } from 'theme-ui';

import { OkendoStars } from '@snippets';
import { useMatchMedia } from '@hooks';

import { Price } from './Price';
import { themed } from './Header.theme';

export const Header = themed(
  ({ theme, selectedVariant, currentProduct, titles, isMobile, ...props }) => {
    const isMobileViewport = useMatchMedia('(max-width: 767px)');
    const isVisibleHeader =
      (isMobile && isMobileViewport) || (!isMobile && !isMobileViewport);

    return (
      <Box sx={{ ...theme.metadata, ...props.sx }}>
        {isVisibleHeader ? (
          <Heading as="h1" sx={theme.title}>
            {titles.product}
          </Heading>
        ) : (
          <Heading as="h2" sx={theme.title}>
            {titles.product}
          </Heading>
        )}

        {titles?.variant && (
          <Paragraph sx={theme.variant}>{titles.variant}</Paragraph>
        )}

        <Flex sx={theme.priceAfterpayWrapper}>
          <Price selectedVariant={selectedVariant} />
          <OkendoStars
            legacyResourceId={currentProduct?.legacyResourceId}
            withScroll
            sx={{ mb: 0, mt: 0, cursor: 'auto' }}
            className="before:content-['_|_'] before:mr-2"
          />
        </Flex>
      </Box>
    );
  }
);

Header.displayName = 'ProductHeader';
